import { GroupBase as DefaultGroupBase, MultiValueProps } from 'react-select';
import { FormState } from 'src/types';
import { MultiSelectComponentContainer } from '../DropdownSelect.styles';
import { DefaultOption } from './DropdownOptions';
import { StyledTag } from './MultiValue.styles';

export const DropdownMultiValue = <
  Option extends DefaultOption = DefaultOption,
  GroupBase extends DefaultGroupBase<Option> = DefaultGroupBase<Option>,
>({
  ...props
}: MultiValueProps<Option, boolean, GroupBase> & {
  readOnly: boolean;
}) => {
  const { disabled } = props.selectProps;

  return (
    <MultiSelectComponentContainer
      onClick={(e) => e.stopPropagation()}
      isMulti={props.isMulti}
    >
      <StyledTag
        text={`${props.data.label}`}
        {...props.removeProps}
        tagLocation={'dropdown'}
        variant={disabled ? 'disabled' : 'default'}
        data-testid={`multi-select-value-${props.data.label}`}
        readOnly={props.readOnly}
        state={
          'tagStateWhenSelected' in props.data
            ? (props.data.tagStateWhenSelected as FormState)
            : undefined
        }
      />
    </MultiSelectComponentContainer>
  );
};
